import type { DifficultyMix } from './difficulty';

export const ROUND_MODES = ['practice', 'test'] as const;

export type RoundMode = (typeof ROUND_MODES)[number];

export const PRACTICE_ROUND_SIZE = 10;

export const ROUND_MIX: Readonly<Record<RoundMode, DifficultyMix>> = {
  practice: { easy: 3, medium: 4, hard: 3 },
  test: { easy: 6, medium: 8, hard: 6 },
};

export const ROUND_STATUSES = ['in_progress', 'completed', 'abandoned'] as const;

export type RoundStatus = (typeof ROUND_STATUSES)[number];

export interface RoundItem {
  readonly questionId: string;
  readonly readingTextId: string | null;
  readonly arrangement: readonly string[] | null;
}
